import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeRoutingModule } from '@app/modules/home/home-routing.module';
import { SharedComponentsModule } from '@app/shared/components/shared-components.module';
import { HomeComponent } from '@app/modules/home/home.component';
import { HomePageDeliveryTabComponent } from '@app/modules/home/components/home-page-delivery-tab/home-page-delivery-tab.component';
import { HomePageCollectionTabComponent } from '@app/modules/home/components/home-page-collection-tab/home-page-collection-tab.component';
import { FooterComponent } from '@app/shared/components/footer/footer.component';
import { HomePageCarouselTabComponent } from '@app/modules/home/components/home-page-carousel-tab/home-page-carousel-tab.component';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { WantedTimePickerComponent } from '@app/shared/components/wanted-time/wanted-time-picker/wanted-time-picker.component';

@NgModule({
  declarations: [
    HomeComponent,
    HomePageDeliveryTabComponent,
    HomePageCollectionTabComponent,
    HomePageCarouselTabComponent
  ],
  imports: [
    CommonModule,
    HomeRoutingModule,
    SharedComponentsModule,
    WantedTimePickerComponent,
    FooterComponent,
    SlickCarouselModule
  ]
})
export class HomeModule { }
